import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const StyledSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid var(--c-border-strong);
  border-top-color: var(--c-accent);
  border-radius: var(--radius-full);
  animation: ${spin} 0.8s linear infinite;
`;
